"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldErrorMessages = exports.getFieldErrorMessageId = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var ErrorMessage_1 = require("./ErrorMessage");
var shared_1 = require("./shared");
var StyledWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ul {\n    list-style: none;\n    > li + li {\n      margin-top: 4px;\n    }\n    ", "\n  }\n"], ["\n  ul {\n    list-style: none;\n    > li + li {\n      margin-top: 4px;\n    }\n    ", "\n  }\n"])), ErrorMessage_1.getErrorMessageStyles(ErrorMessage_1.ERROR_MESSAGE_TYPE.field));
var PRE_ID_NAME = 'FIELD_ERROR_MESSAGE_';
var getFieldErrorMessageId = function (propertyId) { return "" + PRE_ID_NAME + (propertyId !== null && propertyId !== void 0 ? propertyId : ''); };
exports.getFieldErrorMessageId = getFieldErrorMessageId;
var getDisplayNoneIfError = function (displayError) {
    if (displayError) {
        return;
    }
    return {
        display: 'none',
    };
};
var FieldErrorMessages = function (_a) {
    var className = _a.className, propertyId = _a.propertyId, errorMessages = _a.errorMessages, _b = _a.displayError, displayError = _b === void 0 ? false : _b, otherAttribute = __rest(_a, ["className", "propertyId", "errorMessages", "displayError"]);
    return (react_1.default.createElement(StyledWrapper, __assign({ className: className }, otherAttribute, { "data-error-type": ErrorMessage_1.ERROR_MESSAGE_TYPE.field }),
        react_1.default.createElement("div", { role: "alert", style: getDisplayNoneIfError(displayError), id: exports.getFieldErrorMessageId(propertyId) }, displayError && shared_1.hasErrorMessages(errorMessages) && (react_1.default.createElement("ul", null, errorMessages.map(function (errorMessage, i) { return (react_1.default.createElement("li", { key: i },
            react_1.default.createElement(ErrorMessage_1.ErrorMessage, { errorMessage: errorMessage }))); }))))));
};
exports.FieldErrorMessages = FieldErrorMessages;
var templateObject_1;
